The workflow process history of the candidate.

A maximum of 20 process history items can be returned in a single page.
Additional items can be queried using a pagination cursor.

This is null for non-uploaded candidates.
